import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import { Button } from '../../../components/core/Button';
import {globalImport} from "../../../common/globalImports";
import {globalConfigurableData} from "../../../utils/globalConstant";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const OutCome = ({ YesSelected, yesNoSelected }) => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 20,
        marginBottom: 10,
      }}
    >
      <FormTextLabel labelStyles={styles.formTitle} label={"Outcome"} />
      <View style={{ flexDirection: "row", gap: 10 }}>
        <Button
          variant={YesSelected ? "yes" : "yes-inactive"}
          onPress={() => !YesSelected && yesNoSelected(true)}
          size="sm"
          style={[
            styles.btnExternalStyle,
            globalImport.isWeb ? {} : {flex: 0},
          ]}
          translate={true}
        >
          Yes
        </Button>
        <Button
          variant={YesSelected ? "no-inactive" : "no"}
          onPress={() => YesSelected && yesNoSelected(false)}
          size="sm"
          style={[
            styles.btnExternalStyle,
            globalImport.isWeb ? {} : {flex: 0},
          ]}
          translate={true}
        >
          No
        </Button>
      </View>
    </View>
  );
};

export default OutCome;

const styles = StyleSheet.create({
  formTitle: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1
  },
  btnExternalStyle: {
    minWidth: 50,
    paddingVertical: 5,
  },
});
